import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from 'styled-components';
import "./Queue.css"

const Queue = ({playlist, queueNext}) => {
    const { t } = useTranslation();
    const themeContext = useContext(ThemeContext);

    return (
        <div className="musicQueue" style={{background: themeContext.body}}>
            {/* Queue Header */}
            <div className="musicQueue__header">
                <span className="material-icons icon--large">queue_music</span><p>{t('playlist')}</p>
            </div>

            {/* Queue Content */}
            {/* TODO - Bind musicQueue__track element with onClick event to dispatch play action */}
            <div className="musicQueue__content">
                {playlist.map((item) => {
                    return (    
                                            
                        <div className="musicQueue__track" key={item.id} onClick={() => queueNext(item.id)}>
                            <div className="musicQueue__track_title">
                                <p>{item.title}</p>
                            </div>
                            <div className="musicQueue__track_duration">
                            <p>{item.duration}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Queue
